import { motion } from "framer-motion";
import { SOCIALS } from "./footerLinks";

export default function SocialLinks() {
  return (
    <div className="flex gap-2.5">
      {SOCIALS.map(({ name, short, href }) => (
        <motion.a
          key={name}
          href={href}
          target="_blank"
          rel="noreferrer noopener"
          aria-label={name}
          whileHover={{ y: -4 }}
          transition={{ type: "spring", stiffness: 400, damping: 22 }}
          className="grid h-11 w-11 place-items-center rounded-xl border border-line bg-surface-2 text-[14px] font-extrabold text-ink-soft transition-colors hover:border-transparent hover:bg-gradient-to-br hover:from-teal hover:to-teal-2 hover:text-white hover:shadow-[0_8px_20px_rgba(15,118,110,0.35)]"
        >
          {short}
        </motion.a>
      ))}
    </div>
  );
}